import React from "react";


const PositionChangeIndicator = ({difference, className}) => {
    let direction = 'equal';
    if (difference > 0) {
        direction = 'up';
    } else if (difference < 0) {
        direction = 'down';
    }
    return <span className={`${className} icon-change icon-change--${direction}`}/>
};

export default PositionChangeIndicator
